<!-- Dialogs -->
<ui-dialog
    [form]="editEmployeeAdditionalIncome.form"
    (primaryButtonPressed)="
        onSave(
            editEmployeeAdditionalIncome.form,
            editEmployeeAdditionalIncome.employee,
            editEmployeeAdditionalIncome.employeeAdditionalIncome
        )
    "
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel(editEmployeeAdditionalIncome.employeeAdditionalIncome)"
    secondaryButtonLabel="cancel"
    (closing)="onCancel(editEmployeeAdditionalIncome.employeeAdditionalIncome)"
    size="small"
    header="{{ editModalTitle | translate }}"
    [open]="isOpenEmployeeAdditionalIncome"
>
    <app-edit-employee-additional-income
        [companyAdditionalIncome]="companyAdditionalIncome"
        #editEmployeeAdditionalIncome
    ></app-edit-employee-additional-income
></ui-dialog>
<ng-template #displayDash>
    <span>-</span>
</ng-template>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [back]="true" [noTitle]="true"> </app-header>
    <ui-banner *ngIf="pendingPayrollExists" variant="warning" class="margin-bottom-3">
        <p>{{ 'payroll.additional-incomes.pendingPayrollNotice' | translate }}</p>
    </ui-banner>

    <div class="ui stackable grid">
        <div class="wide column {{ !companyAdditionalIncome.recurrable ? 'sixteen' : 'six' }}">
            <div class="ui segment">
                <app-segment-header [title]="companyAdditionalIncome.displayName"></app-segment-header>

                <form class="ui form">
                    <div class="field">
                        <label>{{ 'forms.setup-personal.provinceStateLabel' | translate }}</label>
                        <mat-form-field>
                            <mat-select
                                [placeholder]="'forms.setup-personal.provinceStatePlaceholder' | translate"
                                [(ngModel)]="selectedProvince"
                                name="province"
                            >
                                <mat-option *ngFor="let province of provinces" [value]="province">
                                    {{ 'provinces.' + province | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="field">
                        <label>{{ 'payroll.additional-incomes.description' | translate }}</label>
                        {{ companyAdditionalIncome.description || '-' }}
                    </div>
                    <div class="field">
                        <label>{{ 'payroll.additional-incomes.taxesAndCalculationsApplied' | translate }}</label>
                        <app-additional-income-taxation
                            [companyAdditionalIncome]="companyAdditionalIncome"
                            [selectedProvince]="selectedProvince"
                        ></app-additional-income-taxation>
                    </div>
                    <div class="field">
                        <label>{{ 'payroll.additional-incomes.taxForms' | translate }} </label>
                        <div class="inline field">
                            <label>{{ 'payroll.additional-incomes.t4' | translate }}&nbsp;</label>
                            <span *ngIf="companyAdditionalIncome.t4Boxes?.length; else displayDash">
                                <span *ngFor="let t4Box of companyAdditionalIncome.t4Boxes; last as isLast"
                                    >{{ 'payroll.additional-incomes.box' | translate: { code: t4Box.boxNumber }
                                    }}<span *ngIf="!isLast">,&nbsp;</span>
                                </span>
                            </span>
                        </div>
                        <div class="inline field" *ngIf="hasQcPayrollFeature">
                            <label>{{ 'payroll.additional-incomes.rl1' | translate }}&nbsp;</label>
                            <span *ngIf="companyAdditionalIncome.rl1Boxes?.length; else displayDash">
                                <span *ngFor="let rl1Box of companyAdditionalIncome.rl1Boxes; last as isLast"
                                    >{{ 'payroll.additional-incomes.box' | translate: { code: rl1Box.code }
                                    }}<span *ngIf="!isLast">,&nbsp;</span>
                                </span>
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div *ngIf="!companyAdditionalIncome.recurrable ? false : true" class="ten wide column">
            <div class="ui table segment">
                <table class="ui selectable unstackable table">
                    <thead>
                        <tr>
                            <th>{{ 'payroll.additional-incomes.name' | translate }}</th>
                            <th>{{ 'payroll.additional-incomes.amountPerPeriod' | translate }}</th>
                            <th class="collapsing"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let employee of employees">
                            <td>{{ employee.fullName }}</td>

                            <!-- Show the amount if it is active -->
                            <td *ngIf="employee.employeeAdditionalIncome?.active">
                                {{ employee.employeeAdditionalIncome?.amount | i18nNum }}
                            </td>

                            <!-- Show a dash if it is inactive -->
                            <td *ngIf="!employee.employeeAdditionalIncome?.active">{{ '-' }}</td>
                            <td>
                                <app-context-menu *ngIf="!pendingPayrollExists" #menu>
                                    <app-context-item
                                        [label]="
                                            employee.employeeAdditionalIncome?.amount
                                                ? 'payroll.additional-incomes.edit'
                                                : 'payroll.additional-incomes.addAmount'
                                        "
                                        (click)="
                                            editEmployeeAdditionalIncome.setEmployee(
                                                employee,
                                                employee.employeeAdditionalIncome
                                            );
                                            setEditModalTitle(employee);
                                            isOpenEmployeeAdditionalIncome = true
                                        "
                                    ></app-context-item>
                                    <app-context-item
                                        *ngIf="employee.employeeAdditionalIncome?.active"
                                        label="{{ 'payroll.additional-incomes.remove' | translate }}"
                                        (click)="onRemove(employee.employeeAdditionalIncome); menu.hide()"
                                    ></app-context-item>
                                </app-context-menu>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
